import { useRouter } from '@/hooks';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { containedButtonStyle } from '@/theme';

export const BackButton = () => {
  const router = useRouter();

  return (
    <Button
      variant="contained"
      sx={{ ...containedButtonStyle, cursor: 'pointer', pt: 1 }}
      startIcon={<ArrowBackIcon />}
      onClick={() => router.back()}
    >
      Back
    </Button>
  );
};
